import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Routes from "./routes";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import "./css/styles.css";
import { CircularProgress } from "@mui/material";
import Dialogs from "./components/Dialog";
import Navigation from "./components/Nav";
import { googleTagManagerScript } from "./analytics";
import { get } from "lodash";

var pjson = require("../package.json");

export default function App() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  const analyticsEnabled = useSelector((state) =>
    get(state, "cookieCompliance.analytics")
  );

  const handleLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    dispatch({
      type: "INITIALIZE_APP",
    });
  }, [dispatch]);

  useEffect(() => {
    if (analyticsEnabled) {
      googleTagManagerScript();
    }
  }, [analyticsEnabled]);

  if (loading) {
    <div className="loading-screen flex-center">
      <CircularProgress
        style={{ width: "60px", height: "60px" }}
        className="circ-progress"
      />
    </div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <ScrollToTop>
        <Dialogs />
        <Navigation />
        <div id="app-body">
          <Routes loading={handleLoading} />
        </div>
        <Footer />
      </ScrollToTop>
    </ThemeProvider>
  );
}
